export default __webpack_public_path__ + "static/media/bmarbled.3a8ba3bf.jpg";